import { Icon, IconProps } from '@chakra-ui/react';

export function AutoRenewIcon(props: IconProps): JSX.Element {
  return (
    <Icon
      width="14"
      height="20"
      viewBox="0 0 14 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M1.25041 13.3737C0.944851 12.8459 0.715685 12.3043 0.562907 11.7487C0.410129 11.1931 0.33374 10.6237 0.33374 10.0404C0.33374 8.17925 0.979573 6.59592 2.27124 5.29037C3.56291 3.98481 5.1393 3.33203 7.00041 3.33203H7.14624L5.81291 1.9987L6.97957 0.832031L10.3129 4.16536L6.97957 7.4987L5.81291 6.33203L7.14624 4.9987H7.00041C5.61152 4.9987 4.43096 5.48828 3.45874 6.46745C2.48652 7.44662 2.00041 8.63759 2.00041 10.0404C2.00041 10.4015 2.04207 10.7556 2.12541 11.1029C2.20874 11.4501 2.33374 11.7904 2.50041 12.1237L1.25041 13.3737ZM7.02124 19.1654L3.68791 15.832L7.02124 12.4987L8.18791 13.6654L6.85457 14.9987H7.00041C8.38929 14.9987 9.56985 14.5091 10.5421 13.5299C11.5143 12.5508 12.0004 11.3598 12.0004 9.95703C12.0004 9.59592 11.9587 9.24175 11.8754 8.89453C11.7921 8.54731 11.6671 8.20703 11.5004 7.8737L12.7504 6.6237C13.056 7.15148 13.2851 7.69314 13.4379 8.2487C13.5907 8.80426 13.6671 9.3737 13.6671 9.95703C13.6671 11.8181 13.0212 13.4015 11.7296 14.707C10.4379 16.0126 8.86152 16.6654 7.00041 16.6654H6.85457L8.18791 17.9987L7.02124 19.1654Z" />
    </Icon>
  );
}
